import { get, post } from "../../utils/request";

export const getListSecurityQuestion = async () => {
  const res = await get("security-question");
  return res;
};

export const createNewUser = async (data) => {
  const res = await post(`users`, data);
  return res;
};

export const getListUsers = async () => {
  const res = await get("users");
  return res;
};
